import { styled } from '@mui/system';
import React from 'react';

const LayoutStyels = styled('div')`
    padding-left: 10px;
    padding-right: 10px;
    margin-right: auto;
    margin-left: auto;
    z-index: 1000 !important;
`
export default function Layout({children}) {

  return (
    <LayoutStyels>{children}</LayoutStyels>
  )
}
